import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { getApiByFriendlyName } from '../../redux/actions/apis';
import { getPlanByApiAndOrganization } from '../../redux/actions/plans';
import ApiKeysTable from './components/ApiKeysTable';

const ApiKeysPage = (props) => {
  useEffect(() => {
    if (!props.api || props.api.uriFriendlyName !== props.match.params.name) {
      props.getApiByFriendlyName(props.match.params.name);
    }
  }, [props.api]);

  useEffect(() => {
    if (props.user && props.api.id && !props.plan.id && !props.planError) {
      props.getPlanByApiAndOrganization();
    }
  }, [props.api, props.user, props.plan.id, props.planError, props.apiError]);

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h2 className="page-title">API Keys</h2>
          <ApiKeysTable />
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  api: state.apis.detailApi,
  user: state.users.user,
  plan: state.plans.detailPlan,
  planError: state.plans.error,
  apiError: state.apis.error
});

const mapDispatchToProps = (dispatch) => ({
  getApiByFriendlyName: (payload) => dispatch(getApiByFriendlyName(payload)),
  getPlanByApiAndOrganization: () => dispatch(getPlanByApiAndOrganization())
});

export default connect(mapStateToProps, mapDispatchToProps)(ApiKeysPage); 